import { TokenExpired } from 'components/tokenExpired';
import { Unauthorized } from 'components/unauthorized';
import { useCanAccess } from 'hooks';
import { IngestTestingPage } from 'pages/ingest-testing';
import { isIngestTestingAvailable } from 'utils/ingestTesting';

export const IngestTestingManagementRoute = () => {
  const { canAccess, isAdmin, isExpired } = useCanAccess('ingest-testing');

  if (isExpired) return <TokenExpired />;
  if (!isIngestTestingAvailable()) return <Unauthorized />;
  return canAccess || isAdmin ? <IngestTestingPage /> : <Unauthorized />;
};
